import { useState } from "react";
import { PlusIcon } from "@heroicons/react/24/solid";
import { Button } from "@headlessui/react";
import ModalFrame from "../../components/ModalFrame";
import AddCourseByAdminForm from "./AddCourseByAdminForm";

export default function AddCourseByAdmin(props: { schoolId: number }) {
	const [isDialogOpen, setIsDialogOpen] = useState(false);

	const handleClick = () => {
		setIsDialogOpen(true);
	};

	const handleDialogClose = () => setIsDialogOpen(false);

	return (
		<>
			<Button id="add-course-button" className="btn btn-primary" onClick={handleClick}>
				<span className="flex items-center">
					<PlusIcon className="size-4 mr-2" /> Add
				</span>
			</Button>

			<AddCourseDialog
				schoolId={props.schoolId}
				isDialogOpen={isDialogOpen}
				onClose={handleDialogClose}
			/>
		</>
	);
}

interface AddCourseDialogProps {
	schoolId: number;
	isDialogOpen: boolean;
	onClose: () => void;
}

function AddCourseDialog(props: AddCourseDialogProps) {
	return (
		<ModalFrame
			open={props.isDialogOpen}
			title="Add a New Course"
			overflow="overflow-visible"
			onClose={() => props.onClose()}>
			<AddCourseByAdminForm schoolId={props.schoolId} onClose={props.onClose} />
		</ModalFrame>
	);
}
